module.exports = __webpack_public_path__ + "img/4.7faf6b53.jpg";